import React from "react";
import "./Hero.css";

import { Box, Container, Typography } from "@mui/material";

import { FaPhoneAlt, FaStar, FaWhatsapp } from "react-icons/fa";

import { motion } from "framer-motion";

import {
  AccessTimeOutlined,
  LocalShippingOutlined,
  SpaOutlined,
  StarBorderOutlined
} from "@mui/icons-material";
import { FaSoap, FaTshirt, FaWind } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function Hero() {
  const navigate = useNavigate()
  const items = [
    {
      icon: <LocalShippingOutlined />,
      title: "Free Pickup",
      subtitle: "& Delivery",
    },
    {
      icon: <SpaOutlined />,
      title: "Eco Friendly",
      subtitle: "Cleaning",
    },
    {
      icon: <AccessTimeOutlined />,
      title: "Same Day",
      subtitle: "Service",
    },
    {
      icon: <StarBorderOutlined />,
      title: "5 Star",
      subtitle: "Rated",
    },
  ];
  const customers = [
    "https://i.pravatar.cc/40?img=12",
    "https://i.pravatar.cc/40?img=32",
    "https://i.pravatar.cc/40?img=47",
    "https://i.pravatar.cc/40?img=4",
  ];

  return (
    <>
      <Box className="hero-section">
        {/* GLOW */}

        <Box className="hero-glow glow-1"></Box>
        <Box className="hero-glow glow-2"></Box>

        <Container maxWidth="xl">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              // justifyContent: "flex-start",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: { xs: "60px", md: "40px" },
            }}
          >
            {/* LEFT */}

            <Box
              sx={{
                flex: "1 1 550px",
                position: "relative",
                zIndex: 2,
              }}
            >
              <motion.div
                initial={{ opacity: 0, y: 70 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                {/* BADGE */}

                <Box
                  sx={{
                    display: "inline-flex",

                    alignItems: "center",

                    gap: 1.5,

                    px: {
                      xs: 2,
                      md: 2.5,
                    },

                    py: {
                      xs: 1,
                      md: 1.2,
                    },

                    borderRadius: "999px",

                    background: "rgba(255,255,255,0.55)",

                    backdropFilter: "blur(16px)",

                    border: "1px solid rgba(0,87,255,.08)",

                    boxShadow: "0 10px 30px rgba(0,87,255,.06)",

                    mb: 3,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,

                      color: "#0057ff",

                      fontSize: {
                        xs: "13px",
                        md: "15px",
                      },
                    }}
                  >
                    <FaTshirt />
                    <FaSoap />
                    <FaWind />
                    <FaStar />
                  </Box>

                  <Typography
                    sx={{
                      fontWeight: 600,

                      color: "#0057ff",

                      fontSize: {
                        xs: "8px",
                        md: "10px",
                      },

                      letterSpacing: ".5px",

                      textTransform: "uppercase",
                    }}
                  >
                    One Stop Care Cleaning Printing
                  </Typography>
                </Box>

                {/* TITLE */}

                <Typography
                  variant="h1"
                  sx={{
                    fontWeight: 700,

                    lineHeight: 1.1,

                    mb: 3,

                    fontSize: {
                      xs: "32px",
                      sm: "32px",
                      md: "62px",
                    },

                    color: "#0f172a",

                    fontFamily: "Poppins",
                  }}
                >
                  Premium Cleaning, Printing
                  <span className="gradient-text"> & One Stop Care </span>
                  Under One Roof
                </Typography>

                {/* SUBTITLE */}

                <Typography
                  sx={{
                    color: "#64748b",

                    lineHeight: 1.8,

                    fontSize: {
                      xs: "15px",
                      md: "18px",
                    },

                    mb: 4,

                    maxWidth: "620px",
                  }}
                >
                  Dry cleaning, shoe care, alterations, custom printing, wedding
                  garments, handbags, rugs, comforters and home essentials
                  professionally cared for across Ajax.
                </Typography>

                {/* POINTS */}

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexWrap: "nowrap",

                    gap: {
                      xs: 1,
                      md: 1.5,
                      lg: 2,
                    },

                    mt: 4,

                    maxWidth: {
                      xs: "100%",
                      md: "520px",
                    },
                  }}
                >
                  {items.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        width: {
                          xs: "25%",
                          md: "95px",
                        },

                        display: "flex",
                        flexDirection: "column",

                        alignItems: "center",

                        textAlign: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: {
                            xs: 50,
                            md: 48,
                          },

                          height: {
                            xs: 50,
                            md: 48,
                          },

                          borderRadius: "50%",

                          background: "#fff",

                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",

                          mb: 1,

                          boxShadow: "0 6px 16px rgba(0,87,255,0.06)",
                        }}
                      >
                        {React.cloneElement(item.icon, {
                          sx: {
                            color: "#0057ff",

                            fontSize: {
                              xs: 20,
                              md: 22,
                            },
                          },
                        })}
                      </Box>

                      <Typography
                        sx={{
                          fontSize: {
                            xs: "10px",
                            md: "11px",
                          },

                          lineHeight: 1.3,

                          fontWeight: 500,

                          color: "#0f172a",
                        }}
                      >
                        {item.title}
                        <br />
                        {item.subtitle}
                      </Typography>
                    </Box>
                  ))}
                </Box>

                {/* BUTTONS */}

                <Box
                  sx={{
                    display: "flex",

                    alignItems: "center",

                    gap: {
                      xs: 1,
                      sm: 1.5,
                      md: 2,
                    },

                    mt: 4,

                    width: {
                      xs: "100%",
                      md: "auto",
                    },

                    maxWidth: {
                      xs: "100%",
                      md: "500px",
                    },
                  }}
                >
                  {/* CALL BUTTON */}

                  <Box
                    component="a"
                    href="tel:+19054283542"
                    sx={{
                      width: {
                        xs: "50%",
                        md: "170px",
                        lg: "190px",
                      },

                      height: {
                        xs: 48,
                        md: 52,
                      },

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "center",

                      gap: 1,

                      borderRadius: "999px",

                      background: "linear-gradient(135deg,#0057ff,#2f89ff)",

                      color: "#fff",

                      textDecoration: "none",

                      fontWeight: 600,

                      fontSize: {
                        xs: "14px",
                        md: "16px",
                      },

                      boxShadow: "0 12px 30px rgba(0,87,255,.20)",

                      transition: ".3s ease",

                      "&:hover": {
                        transform: "translateY(-2px)",

                        boxShadow: "0 18px 35px rgba(0,87,255,.28)",
                      },
                    }}
                   
                  >
                    <FaPhoneAlt />
                    Call Now
                  </Box>

                  {/* WHATSAPP BUTTON */}

                  <Box
                    component="a"
                    href="https://wa.me/+19054283542"
                    target="_blank"
                    rel="noreferrer"
                    sx={{
                      width: {
                        xs: "50%",
                        md: "170px",
                        lg: "190px",
                      },

                      height: {
                        xs: 48,
                        md: 52,
                      },

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "center",

                      gap: 1,

                      borderRadius: "999px",

                      background: "#fff",

                      color: "#25D366",

                      textDecoration: "none",

                      fontWeight: 600,

                      fontSize: {
                        xs: "14px",
                        md: "16px",
                      },
                      border: "1px solid rgba(0,0,0,.06)",

                      boxShadow: "0 10px 25px rgba(0,0,0,.04)",

                      transition: ".3s ease",

                      "&:hover": {
                        transform: "translateY(-2px)",

                        boxShadow: "0 16px 30px rgba(0,0,0,.08)",
                      },
                    }}
                  >
                    <FaWhatsapp />
                    WhatsApp Us
                  </Box>
                </Box>

                <Box
                  sx={{
                    mt: 2.5,

                    display: "inline-flex",

                    alignItems: "center",

                    gap: 1.5,

                    background: "rgba(255,255,255,0.88)",

                    backdropFilter: "blur(12px)",

                    borderRadius: "999px",

                    px: {
                      xs: 1.5,
                      md: 2,
                    },

                    py: {
                      xs: 0.8,
                      md: 1,
                    },

                    boxShadow: "0 8px 25px rgba(0,87,255,.05)",

                    width: "fit-content",

                    maxWidth: "100%",
                  }}
                >
                  {/* AVATARS */}

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {customers.map((img, index) => (
                      <Box
                        key={index}
                        component="img"
                        src={img}
                        alt="Customer"
                        sx={{
                          width: {
                            xs: 28,
                            md: 32,
                          },

                          height: {
                            xs: 28,
                            md: 32,
                          },

                          borderRadius: "50%",

                          objectFit: "cover",

                          border: "2px solid #fff",

                          ml: index === 0 ? 0 : "-10px",

                          boxShadow: "0 2px 8px rgba(0,0,0,.08)",
                        }}
                      />
                    ))}
                  </Box>

                  {/* CONTENT */}

                  <Box>
                    <Typography
                      sx={{
                        color: "#f59e0b",

                        fontSize: {
                          xs: "11px",
                          md: "13px",
                        },

                        lineHeight: 1,

                        fontWeight: 700,

                        mb: 0.2,
                      }}
                    >
                      ★★★★★
                    </Typography>

                    <Typography
                      sx={{
                        color: "#475569",

                        fontSize: {
                          xs: "10px",
                          md: "12px",
                        },

                        lineHeight: 1.2,

                        fontWeight: 500,
                      }}
                    >
                      Trusted by 1,000+ Customers in Ajax
                    </Typography>
                  </Box>
                </Box>
              </motion.div>
            </Box>

            {/* RIGHT */}

            <Box
              sx={{
                flex: "1 1 500px",
                position: "relative",
                zIndex: 2,
              }}
            ></Box>
          </Box>
        </Container>
      </Box>
    </>
  );
}

export default Hero;
